import { Controller } from "@hotwired/stimulus"

// The five names under the hatch field. Pressing one fills the field and
// marks the chip; the field stays editable, so a suggestion is a start as
// much as an answer.
export default class extends Controller {
  static targets = ["field"]

  pick(event) {
    const name = event.currentTarget.dataset.name
    if (!name || !this.hasFieldTarget) return

    this.fieldTarget.value = name
    this.fieldTarget.focus()
    this.element.querySelectorAll(".ll-chip").forEach((chip) => {
      chip.setAttribute("aria-pressed", chip === event.currentTarget ? "true" : "false")
    })
  }
}
